//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import React from 'react';
import styled from 'styled-components';

import { useSamplingCampaign } from '@campaigns/hooks/useSamplingCampaign';
import { Alert } from '@components/atoms/alert/Alert';
import { BodyErrorText } from '@components/atoms/text/Text';
import { Mixins } from '@theme/mixins';
import { isDefined } from '@utils/filterPredicates';

interface ProductDetailsModalAlertsProps {
  errorMessages: string[];
  isViewOnly: boolean;
}

export const ProductDetailsModalAlerts = ({
  errorMessages,
  isViewOnly,
}: ProductDetailsModalAlertsProps) => {
  const { selectedRetailer } = useSamplingCampaign();

  return (
    <>
      <Alert type='info'>
        {isDefined(selectedRetailer) ? (
          <>
            Our team will add new products to the
            <RetailerName>{selectedRetailer.bvClientId}</RetailerName>
            catalog once the request is approved.
          </>
        ) : (
          'Our team will add new products to your catalog once the request is approved.'
        )}
      </Alert>
      {!isViewOnly && errorMessages.length > 0 && (
        <Alert type='error'>
          <BodyErrorText>Please fix the following errors:</BodyErrorText>
          <ErrorList>
            {errorMessages.map((error, index) => (
              <ErrorItem key={index}>{error}</ErrorItem>
            ))}
          </ErrorList>
        </Alert>
      )}
    </>
  );
};

const ErrorList = styled.ul`
  list-style-type: none;
  padding: 0;
  margin: 0;
`;

const ErrorItem = styled.li`
  ${Mixins.Text.BodyError}
  margin-bottom: ${({ theme }) => theme.spacings[1]};

  &:last-child {
    margin-bottom: 0;
  }
`;

const RetailerName = styled.span(
  ({ theme }) => `
    ${Mixins.Text.BodyBold}
    color: ${theme.colors.cyan8};
    padding: 0 ${theme.spacings[1]};
  `,
);
